export const en = {
  // Header
  header: {
    contact: "Contact",
    services: "Services",
    servicesDropdown: {
      flexibleWorkstations: "Flexible workstations",
      privateOffices: "Private offices",
      meetingRooms: "Meeting rooms",
      commonSpaces: "Common spaces"
    }
  },

  // Homepage
  home: {
    title: "Your workspace, ",
    title2: "your inspiration",
    subtitle: "A modern coworking space in France, designed to stimulate creativity, collaboration and productivity.",
    reserveButton: "Book now",
    gallery: {
      rotateHint: "Rotate your device for the best viewing experience"
    }
  },

  // Contact Page
  contact: {
    title: "Contact Us",
    form: {
      name: "Name & Surname",
      namePlaceholder: "Your name",
      email: "Email",
      emailPlaceholder: "Your email",
      phone: "Phone",
      phonePlaceholder: "Your phone",
      message: "Message",
      messagePlaceholder: "Your message",
      submit: "Send"
    },
    info: {
      title: "Contact Information",
      phone: "06 88 61 58 11",
      email: "contact@spotin-france.fr",
      address: "54 rue du Général de Gaulle, Belhomert-Guéhouville, France, 28240"
    },
    success: "✅ Message sent successfully!",
    error: "❌ Error sending message.",
    networkError: "📡 Unable to send message."
  }
};
